<template>
  <section class="more-stories-section" id="more-stories">
    <v-container>
      <!-- Header Section -->
      <v-row justify="left" class="header-row" v-if="showTitle">
        <v-col cols="12" justify="left">
          <h2 class="section-title">
            More <span class="underline">Stories</span>
          </h2>
        </v-col>
      </v-row>

      <!-- Stories Section -->
      <v-row :justify="justifyContent" class="stories-row">
        <v-col
          class="story-col"
          cols="12"
          sm="12"
          md="6"
          lg="4"
          v-for="story in filteredStories"
          :key="story.id"
        >
          <story-card
            :image="story.image"
            :tags="story.tags"
            :title="story.name"
            :description="story.description"
            :logo="story.logo"
            :route="story.route"
            :max-width="400"
            :aspect-ratio="aspectRatio"
          />
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import StoryCard from '../../Sections/StoryCard.vue';

export default {
  name: 'MoreStories',
  components: {
    'story-card': StoryCard,
  },
  props: {
    currentStoryId: {
      type: String,
      required: true,
    },
    stories: {
      type: Array,
      required: true,
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
    aspectRatio: {
      type: [String, Number],
      default: 1.777,
    },
    justifyContent: {
      type: String,
      default: 'left',
      validator: (value) =>
        ['left', 'center', 'right', 'space-between', 'space-around', 'space-evenly'].includes(value),
    },
  },
  computed: {
    filteredStories() {
      // Filter out the current story based on its ID
      // Convert both to strings for comparison since currentStoryId is passed as string
      return this.stories.filter((story) => story.id.toString() !== this.currentStoryId);
    },
  },
};
</script>

<style scoped>
.more-stories-section {
  text-align: left;
}

.section-title {
  font-size: 42px;
  font-weight: 700;
  position: relative;
  display: inline-block;
}

.underline {
  position: relative;
  display: inline-block;
  color: #ff6860; /* Red color for "Stories" to match the design */
}

.stories-row {
  margin-inline: auto;
  display: flex;
  max-width: 1200px;
}

.story-col {
  display: flex;
  justify-content: center;
  margin-bottom: 2rem;
}

@media (max-width: 768px) {
  .section-title {
    font-size: 32px;
  }

  .story-col {
    padding: 15px;
    justify-content: center;
  }
}
</style>